import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  href,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-charcoal-900 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-amber-400 text-charcoal-900 hover:bg-amber-300 hover:shadow-[0_0_15px_rgba(212,165,116,0.3)] active:transform active:scale-[0.98]',
    secondary: 'bg-charcoal-700 text-cream-100 hover:bg-charcoal-600 border border-charcoal-600',
    outline: 'bg-transparent border border-amber-400/50 text-amber-400 hover:bg-amber-400/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg font-semibold tracking-wide'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className || ''}`;
  if (href) {
    const isInternalLink = href.startsWith('#');
    return <a href={href} target={isInternalLink ? undefined : '_blank'} rel={isInternalLink ? undefined : 'noopener noreferrer'} className={combinedClassName} data-id="element-192">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-193">
      {children}
    </button>;
}